import { t } from "i18next";

import { colors } from "#app/theme/v1/colors";
import { QuoteRequestLineDto } from "#modules/quoteRequestLines/infra/fetchQuoteRequestLine.api";
import { ProcessStepFromQuoteRequestLine } from "#modules/similarPart/view/clustering/CompareCard";
import { CompareProcessStepLine } from "#modules/similarPart/view/clustering/CompareProcessStepLine";
import { Paper } from "#shared/view/components/Paper";
import { Stack } from "#shared/view/components/Stack";
import { Text } from "#shared/view/components/Text";

export const CompareProcessStepLines = ({
  processSteps,
  selectedQuoteRequestLine,
  sourceQuoteRequestLine,
}: {
  processSteps: ProcessStepFromQuoteRequestLine[];
  selectedQuoteRequestLine: QuoteRequestLineDto;
  sourceQuoteRequestLine: QuoteRequestLineDto;
}) => {
  if (!processSteps.length) {
    return <Text>{t("similarPart.compare.noSteps")}</Text>;
  }

  return (
    <Paper p="xxs" radius={4} bg={colors.gray[1]}>
      <Stack gap="xs" justify="space-between">
        {processSteps.map((processStep) => {
          return (
            <CompareProcessStepLine
              key={processStep.id}
              processStep={processStep}
              targetQuoteRequestLine={selectedQuoteRequestLine}
              sourceQuoteRequestLine={sourceQuoteRequestLine}
            />
          );
        })}
      </Stack>
    </Paper>
  );
};
